
import {eventBus} from "@/services/event-bus";
import Vue from "vue";
import PartyService from "../services/party.service"
import ActivityService from "../services/activity.service"
import Party from "@/models/party";
import Activity from "@/models/activity";
import {TimePickerPlugin} from '@syncfusion/ej2-vue-calendars';

Vue.use(TimePickerPlugin);

export default Vue.extend({

  name: 'EditPersonForm',
  props: ['userType'],
  methods: {
    showForm() {
      this.isVisible = true;
    },
    hideForm() {
      this.isVisible = false;
    },
    clearForm() {
      this.person = new Party(0);
      this.password = '';
      this.passwordConfirmation = '';
      this.isFormValid = true;
    },
    refreshForm: function () {
      // eslint-disable-next-line no-console
      console.log("refresh");
      this.clearForm();
      if (this.person.id != null) {
        this.loadPerson(this.person.id);
      }
    },
    cancelForm: function () {
      // eslint-disable-next-line no-console
      console.log("cancel");
      this.hideForm();
    },
    setLogin: function () {
      if (this.person.name && this.person.surname) {
        this.person.login = (this.person.name.at(0)+this.person.surname).toLowerCase();
      }
    },
    submitForm: function () {
      // eslint-disable-next-line no-console
      console.log("submit");
      this.validateForm();
      if (this.isFormValid) {
        this.writePerson();
        eventBus.$emit('refresh-party-list');
        this.hideForm();
      }
    },
    validateForm() {
      // eslint-disable-next-line no-console
      console.log("validate");
      if (this.form.validate()) {
        this.isFormValid = true;
        return
      }
      this.isFormValid = false
    },
    onLoad: function (d: any) {
      // eslint-disable-next-line no-console
      console.log(d);
      return this.person = d;
    },
    loadPerson(personId: number) {
      // eslint-disable-next-line no-console
      console.log(this.userType);
      if (this.userType === 'therapists') {
        return PartyService.therapistById(personId).then(this.onLoad).catch(reason => eventBus.$emit('error', reason));
      }
      return PartyService.patientById(personId).then(this.onLoad).catch(reason => eventBus.$emit('error', reason));
    },
    loadActivitiesAndPerson(personId: number) {
      return ActivityService.activities().then(d => this.activities = d)
          .then(() => this.loadPerson(personId)).catch(reason => eventBus.$emit('error', reason));
    },
    loadActivities() {
      return ActivityService.activities().then(d => this.activities = d)
          .catch(reason => eventBus.$emit('error', reason));
    },
    writePerson() {
      this.updatePassword();
      this.person.type = this.userType === 'therapists' ? 'therapist' : 'patient';
      if (!this.person.id) {
        // eslint-disable-next-line no-console
        console.log("create");
        return PartyService.createParty(this.person, this.password);
      }
      // eslint-disable-next-line no-console
      console.log("update");
      return PartyService.updateParty(this.person, this.password);
    },

    updatePassword() {
      // eslint-disable-next-line no-console
      console.log("updatePass");
      if (this.password && this.passwordConfirmation) {
        // eslint-disable-next-line no-console
        console.log("true");
        // this.person.password = this.password
      }
    }

  },
  mounted() {
    eventBus.$on('edit-person', (personId: number) => {
      // eslint-disable-next-line no-console
      console.log("edit-person:" + personId);
      this.clearForm();
      this.loadActivitiesAndPerson(personId);
      this.showForm();
    });
    eventBus.$on('create-person', () => {
      // eslint-disable-next-line no-console
      console.log("create-person:");
      this.clearForm();
      this.loadActivities();
      this.showForm();
    })
  },
  data() {
    return {
      headers: [
        {text: this.$t('activityName'), value: 'name'},
        {text: this.$t('code'), value: 'code'},
        {text: this.$t('description'), value: 'description'},
      ],
      timeStep: 60,
      timeFormat: 'HH:mm',
      timeVal: new Date(),
      activities: [] as Activity[],
      isVisible: false,
      isFormValid: true,
      person: new Party(0),
      password: '',
      passwordConfirmation: '',
      isPasswordVisible: false,
      nameRules: [
        (v: any) => !!v || 'Imię jest wymagane',
        (v: any) => (v && v.length <= 40) || 'Imię musi być krótsze niż 40 znaków',
      ],
      surnameRules: [
        (v: any) => !!v || 'Nazwisko jest wymagane',
        (v: any) => (v && v.length <= 40) || 'Nazwisko musi być krótsze niż 40 znaków',
      ],
      mobileRules: [
        (v: any) => this.userType==='therapists' || !!v || 'Telefon jest wymagany',
        (v: any) => !v || (v && v.length > 9) || 'Telefon musi mieć conajmniej 9',
      ],
      loginRules: [
        (v: any) => !!v || 'Login jest wymagany',
        (v: any) => (v && v.length <= 20) || 'Login musi być krótszy niż 20 znaków',
      ],
      passwordRules: [
        (v: any) => {
          if (v != null && v.length == 0) return true;
          if (v && v.length < 8) return 'Hasło musi mieć conajmniej 8 znaków';
          if (!/(?=.*[A-Z])/.test(v)) return 'Hasło musi mieć conajmniej jedną dużą literę';
          if (!/(?=.*\d)/.test(v)) return 'Hasło musi mieć conajmniej jedną cyfrę';
          if (!/([!@$%])/.test(v)) return 'Hasło musi mieć conajmniej jeden znak specjalny [!@#$%]';
          return true;
        }
      ],
      passwordConfirmationRules: [
        //(v: any) => (v && v.length >= 8) || 'Hasło musi mieć conajmniej 8 znaków',
      ],
      emailRules: [
        (v: any) => this.userType!=='therapists' || !!v || 'Email jest wymagany',
        (v: any) => !v || /.+@.+\..+/.test(v) || 'E-mail musi być poprawny',
      ],
    }
  },
  computed: {
    form(): Vue & { validate: () => boolean } {
      return this.$refs.form as Vue & { validate: () => boolean }
    },
    samePasswordsRule() {
      return () =>
          this.password === this.passwordConfirmation || "Hasła muszą się zgadzać";
    }
  } // Use it like so: this.form.validate()
})
